import { ModuleData } from '../types';
export const MODULES: ModuleData[] = [{
  id: 'Metriek',
  title: 'Meten & Omrekenen',
  description: 'Lengtematen, gewicht, inhoud, oppervlakte en omtrek omrekenen en berekenen.',
  icon: 'Ruler',
  color: 'text-blue-500'
}, {
  id: 'Getalbegrip',
  title: 'Rekenen & Getallen',
  description: 'Grote getallen, breuken, procenten, verhoudingen en kommagetallen.',
  icon: 'Calculator',
  color: 'text-indigo-500'
}, {
  id: 'TijdGeld',
  title: 'Tijd & Geld',
  description: 'Klokkijken, tijdsduur berekenen, geld samenstellen en wisselgeld.',
  icon: 'Clock',
  color: 'text-emerald-500'
}, {
  id: 'SpellingWW',
  title: 'Werkwoordspelling',
  description: "Stam bepalen, 't Kofschip, verleden tijd en voltooid deelwoord.",
  icon: 'PenTool',
  color: 'text-rose-500'
}, {
  id: 'SpellingRegel',
  title: 'Spelling & Grammatica',
  description: 'Spellingregels, weetwoorden, leenwoorden en zinsontleding.',
  icon: 'BookOpen',
  color: 'text-amber-500'
}, {
  id: 'Taalbegrip',
  title: 'Taalbegrip & Lezen',
  description: 'Begrijpend lezen, woordenschat, verwijswoorden en signaalwoorden.',
  icon: 'MessageSquare',
  color: 'text-purple-500'
}, {
  id: 'Studievaardig',
  title: 'Studievaardigheden',
  description: "Informatie opzoeken, kaartlezen, schema's en tabellen interpreteren.",
  icon: 'Search',
  color: 'text-teal-500'
}, {
  id: 'Topo',
  title: 'Topografie',
  description: 'Topografie van Nederland, Europa en de wereld.',
  icon: 'Globe',
  color: 'text-cyan-500'
}];